import { Tooltip, TooltipContent, TooltipTrigger } from '@tempo-io/sui-tooltip';
import { useTranslation } from 'react-i18next';
import { IconContainer } from './Styled';
import type { SystemIconProps } from './SystemIcon';

export default function IconTooltip({ isSystem, children }: SystemIconProps) {
  const { t } = useTranslation('translation');

  const icon = <div className="flex size-[26px] items-center justify-center">{children}</div>;

  return (
    <IconContainer>
      {isSystem ? (
        <Tooltip>
          <TooltipTrigger asChild>{icon}</TooltipTrigger>
          <TooltipContent>{t(($) => $.intake.general.systemFieldToolTip)}</TooltipContent>
        </Tooltip>
      ) : (
        icon
      )}
    </IconContainer>
  );
}
